module.exports = __webpack_public_path__ + "img/Ageing.a90dbff4.svg";